module.exports = __webpack_public_path__ + "static/DownfallWebCover_LARGE-a537f26fe85e0eb47c15203f0f301ece.jpeg";